"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_TYPES = exports.GenericInput = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var INPUT_TYPES = {
  text: 'text',
  select: 'select',
  textArea: 'text-area'
};
exports.INPUT_TYPES = INPUT_TYPES;
function GenericInput(props) {
  var label = props.label,
    name = props.name,
    type = props.type,
    rules = props.rules,
    placeholder = props.placeholder,
    _a = props.config,
    config = _a === void 0 ? {
      colon: false,
      labelAlign: 'left',
      style: {
        display: 'flex',
        flexDirection: 'column'
      }
    } : _a;
  if (type === INPUT_TYPES.text) {
    return react_1.default.createElement(antd_1.Form.Item, __assign({}, config, {
      name: name,
      label: label,
      rules: rules
    }), react_1.default.createElement(antd_1.Input, __assign({}, props)));
  } else if (type === INPUT_TYPES.textArea) {
    return react_1.default.createElement(antd_1.Form.Item, __assign({}, config, {
      name: name,
      label: label,
      rules: rules
    }), react_1.default.createElement(antd_1.Input.TextArea, __assign({}, props)));
  } else {
    return react_1.default.createElement(antd_1.Form.Item, __assign({}, config, {
      name: name,
      label: label,
      rules: rules
    }), react_1.default.createElement(antd_1.Select, __assign({}, props, {
      options: __spreadArray([{
        label: placeholder,
        value: '',
        disabled: true
      }], props.options || [])
    })));
  }
}
exports.GenericInput = GenericInput;